module.exports =
  ENV: 'development'
  baseApiUrl: process.env.BASE_API_URL || 'http://127.0.0.1:3000'
